export function getScrollbarWidth() {
    // Create the measurement node
    const scrollDiv = document.createElement('div')
    scrollDiv.className = 'scrollbar-measure'
    document.body.appendChild(scrollDiv)
    // Make box scrollable
    scrollDiv.style.overflow = 'scroll'

    // Get the scrollbar width
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth

    // Delete the DIV
    document.body.removeChild(scrollDiv)

    return scrollbarWidth
}
